import React from 'react';

import ReffieTextTooltip from 'src/components/ReffieTextTooltip';
import type { IRegion } from 'src/pages/landlord/leads/messages/components/messages-container/utils/parse-message-line-into-regions';

import styles from 'src/pages/landlord/leads/messages/components/messages-container/Message.module.css';

interface Props {
    regions: IRegion[];
    onDateClick?: (date: Date) => void;
    onContactClick?: (type: 'phone' | 'email', value: string) => void;
}

export default function MessageLine({ regions, onDateClick, onContactClick }: Props) {
    return regions.map((region) => {
        if (region.type === 'url') {
            return (
                <a
                    key={region.key}
                    href={region.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="message-link"
                >
                    {region.text}
                </a>
            );
        }

        if (region.type === 'date' && region.parsedDate && onDateClick) {
            const parsedDate = region.parsedDate;
            return (
                <ReffieTextTooltip key={`tooltip-${region.key}`} title="Click to schedule a showing">
                    <span
                        className={styles.nlpTagDate}
                        role="button"
                        data-testid="message-date-chip"
                        onClick={() => onDateClick(parsedDate)}
                    >
                        {region.text}
                    </span>
                </ReffieTextTooltip>
            );
        }

        if ((region.type === 'phone' || region.type === 'email') && onContactClick) {
            const contactType = region.type;
            return (
                <ReffieTextTooltip
                    key={`tooltip-${region.key}`}
                    title={`Click to add this ${region.type === 'phone' ? 'phone number' : 'email address'} to lead`}
                >
                    <span
                        className={styles.nlpTagDate}
                        role="button"
                        data-testid="message-contact-chip"
                        onClick={() => onContactClick(contactType, region.text)}
                    >
                        {region.text}
                    </span>
                </ReffieTextTooltip>
            );
        }

        return <span key={region.key}>{region.text}</span>;
    });
}
